module.exports = __webpack_public_path__ + "media/images/adv_bg-31da61437c3d7d746bd3a147d9f5b385.png";